import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutePermissionResolver } from '@app/@core/router/route-permission.resolver';
import { QueryBuilderComponent } from '@app/pages/microstrategy/query-builder/query-builder.component';
import { PagesComponent } from '@app/pages/pages.component';
import { ProfileComponent } from '@app/shared/modules/profile/profile.component';
import { AuthGuard } from '@core/auth/auth.guard';
import { BusinessCentralComponent } from './business-central/business-central.component';
import { ChatComponent } from './chat/chat.component';
import { AnalyticsComponent } from './microstrategy/analytics/analytics.component';
import { MastersComponent } from './rbac/masters/masters.component';
import { WorkflowComponent } from './workflow/workflow.component';
import { YouthQuickSearchComponent } from './youth-quick-search/youth-quick-search.component';
import { SupportIntegrationModule } from './support-integration/support-integration.module';
import { ApplicationDashboardComponent } from '@app/application-dashboard/application-dashboard.component';
import { QueuesComponent } from '@app/Queues/queues.component';
import { RegistrationTemplateComponent } from '@app/Queues/registration-template/registration-template.component';
import { SystemConfigurationComponent } from '@app/systemconfiguration/system-configuration/system-configuration.component';
import { UnderDevelopmentComponent } from '@app/shared/under-development/under-development.component';
import { MessageCenterComponent } from '@app/message-center/message-center.component';
import { ComplaintReviewComponent } from '@app/app-login/complaint-form/complaint-review/complaint-review.component';
import { SearchComponent } from '@app/search/search/search.component';
import { LookupUserDetailComponent } from '@app/lookup-user-detail/lookup-user-detail.component';
// import { QueuesAdminComponent } from '@app/Queues/queues-admin/queues-admin.component';
// import { QueuesDevextremComponent } from '@app/Queues/queues-devextrem/queues-devextrem.component';
import { LeaDashboardComponent } from '@app/lea-dashboard/lea-dashboard.component';
import { EppDashboardComponent } from '@app/epp-dashboard/epp-dashboard.component';
import { ComplaintFlowTimelineComponent } from '@app/app-login/complaint-form/complaint-flow-timeline/complaint-flow-timeline.component';
import { SurrenderApplicationComponent } from '@app/surrender/surrender-application/surrender-application.component';
import { SurrenderTimelineComponent } from '@app/surrender/surrender-timeline/surrender-timeline.component';
import { AdminReportsComponent } from '@app/admin-reports/admin-reports.component';
import { EPPReportsComponent } from '@app/epp-reports/epp-reports.component';
import { LEAReportsComponent } from '@app/lea-reports/lea-reports.component';
import { IntakeReportsComponent } from '@app/Dashboard-Reports/intake-reports/intake-reports.component';
import { AnalystReportsComponent } from '@app/Dashboard-Reports/analyst-reports/analyst-reports.component';
import { TrendsReportsComponent } from '@app/Dashboard-Reports/trends-reports/trends-reports.component';
import { DailyDirectorReportsComponent } from '@app/Dashboard-Reports/daily-director-reports/daily-director-reports.component';
import { DeficiencyReportsComponent } from '@app/Dashboard-Reports/deficiency-reports/deficiency-reports.component';
import { PersonnelReportsComponent } from '@app/Dashboard-Reports/personnel-reports/personnel-reports.component';
import { EdPrepReportsComponent } from '@app/Dashboard-Reports/ed-prep-reports/ed-prep-reports.component';
import { DNQReportsComponent } from '@app/Dashboard-Reports/dnq-reports/dnq-reports.component';
import { PaymentReconciliationReportComponent } from '@app/payment-reconciliation-report/payment-reconciliation-report.component';
import { BackgroundReportsComponent } from '@app/Dashboard-Reports/background-reports/background-reports.component';

const routes: Routes = [
  {
    path: '',
    component: PagesComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('@app/pages/dynamic/dynamic.module').then(m => m.DynamicModule),
        data: {
          rootmodulenames: ['YTH'],
          route: '/youth-photo'
        },
        resolve: { permissions: RoutePermissionResolver }
      },
      {
        path: 'cardy-ai',
        loadChildren: () => import('@app/pages/cardy-ai/cardy-ai.module').then(m => m.CardyAiModule),
      },

      {
        path: 'config-dashboard',
        loadChildren: () =>
          import('@app/pages/rbac/config-dashboard/config-dashboard.module').then(m => m.ConfigDashboardModule),
        data: {
          rootmodulenames: ['SETTINGS_CON_DAS'],
          route: '/config-dashboard'
        },
        resolve: { permissions: RoutePermissionResolver }
      },
      {
        path: 'config-dashboard-user',
        loadChildren: () =>
          import('@app/pages/config-dashboard-user/config-dashboard-user.module').then(m => m.ConfigDashboardUserModule),
        data: {
          rootmodulenames: ['DAS'],
          route: '/config-dashboard-user'
        },
        resolve: { permissions: RoutePermissionResolver }
      },
      {
        path: 'document-packetization',
        loadChildren: () =>
          import('@app/pages/document-packetization/document-packetization.module').then(
            m => m.DocumentPacketizationModule
          ),
        data: {
          rootmodulenames: ['DOC_PAC'],
          route: '/document-packetization'
        },
        resolve: { permissions: RoutePermissionResolver }
      },
      {
        path: 'email-template',
        loadChildren: () => import('@app/pages/email-template/email-template.module').then(m => m.EmailTemplateModule),
        data: {
          rootmodulenames: ['EMA_TEM'],
          route: '/email-template'
        },
        resolve: { permissions: RoutePermissionResolver }
      },
      {
        path: 'help-desk',
        loadChildren: () => import('@app/pages/help-desk/help-desk.module').then(m => m.HelpDeskModule)
      },
      {
        path: 'ocr-validation',
        loadChildren: () => import('@app/pages/ocr-validation/ocr-validation.module').then(m => m.OcrValidationModule)
      },
      {
        path: 'setting',
        loadChildren: () => import('@app/pages/setting/setting.module').then(m => m.SettingModule)
      },
      {
        path: 'event-scheduler',
        loadChildren: () =>
          import('@app/pages/event-scheduler/event-scheduler.module').then(m => m.EventSchedulerModule),
        data: {
          rootmodulenames: ['EVE_SCH'],
          route: '/event-scheduler'
        },
        resolve: { permissions: RoutePermissionResolver }
      },
      {
        path: 'main-notification',
        loadChildren: () =>
          import('@app/pages/main-notification/main-notification.module').then(m => m.MainNotificationModule)
      },
      {
        path: 'report-designer',
        component: QueryBuilderComponent
      },
      {
        path: 'analytics',
        data: {
          rootmodulenames: ['ANA'],
          route: '/analytics'
        },
        component: AnalyticsComponent,
        resolve: { permissions: RoutePermissionResolver }
      },
      {
        path: 'workflow',
        component: WorkflowComponent
      },
      {
        path: 'profile',
        component: ProfileComponent
      },
      {
        path: 'manage-profile',
        loadChildren: () => import('./manage-profile/manage-profile.module').then(m => m.ManageProfileModule)
      },
      {
        path: 'masters',
        component: MastersComponent,
        data: {
          rootmodulenames: ['SETTINGS'],
          route: '/masters'
        },
        resolve: { permissions: RoutePermissionResolver }
      },
      {
        path: 'chat',
        component: ChatComponent
      },
      {
        path: 'rbac',
        loadChildren: () => import('@app/pages/rbac/rbac.module').then(m => m.RbacModule),
        data: {
          rootmodulenames: ['SETTINGS'],
          route: '/rbac'
        },
        resolve: { permissions: RoutePermissionResolver }
      },
      {
        path: 'page-design',
        loadChildren: () => import('@app/pages/page-designer/page-designer.module').then(m => m.PageDesignerModule),
        data: {
          rootmodulenames: ['PAG_DES'],
          route: '/page-design'
        },
        resolve: { permissions: RoutePermissionResolver }
      },
      {
        path: 'business-central',
        component: BusinessCentralComponent
      },
      {
        path: 'youthsearch',
        component: YouthQuickSearchComponent
      },
      {
        path: 'my-app',
        component: ApplicationDashboardComponent
      },
      {
        path: 'lea-dashboard',
        component: LeaDashboardComponent
      },
      {
        path: 'queues/:queueName',
        component: QueuesComponent
      },
      // {
      //   path: 'my-dashboard',
      //   redirectTo: 'application-dashboard',
      //   pathMatch: 'full'
      // },
      {
        path: 'my-dashboard',
        component: UnderDevelopmentComponent
      },
      {
          path: 'admin-reports',
          component: AdminReportsComponent,
        },
        {
          path : 'payment-reconcilation-report',
          component: PaymentReconciliationReportComponent
        },
        {
          path: 'epp-reports',
          component: EPPReportsComponent,
        },
        {
          path: 'lea-reports',
          component: LEAReportsComponent,
        },
      {
        path: 'system-config',
        component: SystemConfigurationComponent
      },
      {
        path: 'lookup-search',
        component: SearchComponent
      },
      {
        path: 'lookup-user/:personId',
        component: LookupUserDetailComponent
      },
      {
        path: 'queues/registration-template/:appId',
        component: RegistrationTemplateComponent
      },
       {
        path: 'intake-reports',
        component: IntakeReportsComponent
      },
       {
        path: 'analyst-reports',
        component: AnalystReportsComponent
      },
      {
        path: 'trends-reports',
        component: TrendsReportsComponent
      },
       {
         path: 'daily-director-reports',
         component: DailyDirectorReportsComponent
       },
       {
        path: 'deficiency-reports',
        component: DeficiencyReportsComponent
      },
       {
        path: 'dnq-reports',
        component: DNQReportsComponent
      },
      {
        path: 'background-reports',
        component: BackgroundReportsComponent
      },
       {
        path: 'personnel-reports',
        component: PersonnelReportsComponent
      },
       {
        path: 'ed-prep-reports',
        component: EdPrepReportsComponent
      },
      {
        path: 'fingerprint-portal',
        loadChildren: () => import('@app/fingerprint-portal/fingerprint-portal.module').then(m => m.FingerprintPortalModule)
      },
      {
        path: 'license-dashboard',
        component: ApplicationDashboardComponent
      },
       {
      path: 'message-center',
      component: MessageCenterComponent
      },
      {
        path: 'complaint-review',
        component: ComplaintReviewComponent
      },
      {
        path: 'complaint-timeline',
        component: ComplaintFlowTimelineComponent
      },
      {
        path: 'surrender-application',
        component : SurrenderApplicationComponent
      },
      {
        path: 'surrender-timeline',
        component : SurrenderTimelineComponent
      },
      {
        path: 'support',
        loadChildren: () => import('./support-integration/support-integration.module').then(m => SupportIntegrationModule)
      },
      {
        path: 'platform-builder',
        loadChildren: () => import('./platform-builder/platform-builder.module').then(m => m.PlatformBuilderModule)
      },
      { path: 'quicksight', loadChildren: () => import('./quicksight/quicksight.module').then(m => m.QuicksightModule) },
       {
        path: 'epp-dashboard',
        component: EppDashboardComponent
      }, {
        path: 'in-app-message',
        loadChildren: () =>
          import('./in-app-message/in-app-message.module').then(m => m.InAppMessageModule),
        data: {
          rootmodulenames: ['CASE_INBOX'],
          route: '/in-app-message'
        }
      },
    ],
    data: {
      screen: { modules: ['pages', 'menus'], skip: false }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
